function mapMarketType(data) {
    return {
        id: data[0],
        betOfferTypeId: data[1],
        name: data[2]
    };
}
export function mapSportsbookMarketsUpdate(data) {
    return {
        id: data[0],
        name: data[1],
        isSuspended: data[2],
        tags: data[3],
        sortOrder: data[4]
    };
}
export function mapSportsbookMarket(data) {
    return {
        id: data[0],
        eventId: data[1],
        sportId: data[2],
        leagueId: data[3],
        name: data[4],
        isSuspended: data[5],
        subcategoryId: data[6],
        marketType: mapMarketType(data[7]),
        tags: data[8],
        sortOrder: data[9]
    };
}
//# sourceMappingURL=mapSportsbookMarket.js.map